export default "__VITE_ASSET__3db0fab7__"